import { render, staticRenderFns } from "./nursePresHome.vue?vue&type=template&id=4a628a1f&scoped=true"
import script from "./nursePresHome.vue?vue&type=script&lang=ts"
export * from "./nursePresHome.vue?vue&type=script&lang=ts"
import style0 from "./nursePresHome.vue?vue&type=style&index=0&id=4a628a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a628a1f",
  null
  
)

export default component.exports